module.exports = __webpack_public_path__ + "img/customer1_11.414bfad0.png";